@let icon = glyph();
@if (icon) {
  <span
    class="fr8bot-icon"
    [class]="class()"
    [style.font-family]="icon.font"
    [style.color]="icon.colour ?? null"
    [style.--fr8bot-icon-em-w]="emBox().width"
    [style.--fr8bot-icon-em-h]="emBox().height"
    aria-hidden="true"
    >{{ icon.char }}</span
  >
}
